import { P2GLink } from '@parcel2go/core-ui';
import DropConfirm from './DropConfirm';
import DropItem from './DropItem';
import { SvgDeleteBin } from '@parcel2go/core-ui';
import { SvgParcelReturn } from '@parcel2go/core-ui';
import { P2GGrid } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  restore: (select: boolean) => void;
  deleteItem: () => void;
  direction: 'row' | 'column';
}

export default function SmartSendItemInactiveDrop(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <div style={{ width: props.direction === 'row' ? '100%' : '200px' }}>
      <P2GGrid
        container
        spacing={2}
        justify={props.direction === 'row' ? 'center' : 'flex-start'}
        direction={props.direction || 'column'}
      >
        <DropItem icon={<SvgParcelReturn />} iconSrc="/theme/icons/ParcelReturn.svg">
          <P2GLink variant="body2" onClick={() => props.restore(false)}>
            {t('INCLUDE_BUTTON', { defaultValue: 'Include' })}
          </P2GLink>
        </DropItem>
        <DropItem icon={<SvgDeleteBin />} iconSrc="/theme/icons/DeleteBin.svg">
          <DropConfirm variant="body2" confirm={props.deleteItem}>
            {t('DELETE_BUTTON', { defaultValue: 'Delete' })}
          </DropConfirm>
        </DropItem>
      </P2GGrid>
    </div>
  );
}
